import isNil from 'lodash/isNil';
import uploadAndFinalize from './upload-and-finalize';
import showNotification from './show-notification';

export default async function createSearch(context, { data, csvData }) {
	const searchStore = context.getStore('SearchStore');
	const { service } = context;
	const { title, eventId, description } = data;
	const successMessage = 'Search List Created Successfully';
	const isUploadingAppendage = !isNil(csvData);

	service.createSearch(
		{
			data: {
				title,
				eventId,
				description,
			},
			options: { isUploadingAppendage },
		},
		() => {
			const {
				error,
				searches: [{ id }],
			} = searchStore.getState();

			if (isNil(error) && isUploadingAppendage) {
				uploadAndFinalize(context, { id, csvData, successMessage });
			} else if (isNil(error)) {
				showNotification(context, {
					heading: successMessage,
					color: 'success',
				});
			}
		},
	);
}
